import { render, staticRenderFns } from "./ResponsesDialog.vue?vue&type=template&id=b4e1635a&scoped=true"
import script from "./ResponsesDialog.vue?vue&type=script&lang=js"
export * from "./ResponsesDialog.vue?vue&type=script&lang=js"
import style0 from "./ResponsesDialog.vue?vue&type=style&index=0&id=b4e1635a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e1635a",
  null
  
)

export default component.exports